import React from 'react';

import ButtonDropdown from 'components/ButtonDropdown';

import {formatDate} from 'utils/datetime';

import {SCHEDULE_TYPES} from 'ducks/tenancy';

import ArrowDelimiter from './assets/enlarge-horizontal.svg';
import './styles.css';

const BaseInformation = ({
  draftInvoice,
  scheduleType,
  approveDraftInvoice,
  deleteDraftInvoice
}) => (
  <div className="BaseInformation">
    <div className="data">
      <div className="section  colab-row-space-between">
        <div className="header">To</div>
        <div className="text">{draftInvoice.tenant.fullName}</div>
      </div>
      <div className="section  colab-row-space-between">
        <div className="header">Date</div>
        <div className="text">{formatDate(draftInvoice.dateIssued)}</div>
      </div>

      <div className="section  colab-row-space-between">
        <div className="header">Due Date</div>
        <div className="text">{formatDate(draftInvoice.dueDate)}</div>
      </div>

      <div className="section  colab-row-space-between">
        <div className="header">Account</div>
        <div className="text">{`${draftInvoice.xeroAccount.code} - ${
          draftInvoice.xeroAccount.name
        }`}</div>
      </div>

      {scheduleType === SCHEDULE_TYPES.RENT && (
        <div className="section colab-row-space-between">
          <div className="header">Rent Period</div>
          <div className="text colab-centered-v">
            <div>{formatDate(draftInvoice.rentStart)}</div>
            <img src={ArrowDelimiter} alt="Arrow delimiter" />
            <div>{formatDate(draftInvoice.rentEnd)}</div>
          </div>
        </div>
      )}
    </div>

    <div className="options">
      <ButtonDropdown
        title="Draft Invoice options"
        menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
        <ButtonDropdown.Option onClick={deleteDraftInvoice}>
          Delete Draft Invoice
        </ButtonDropdown.Option>
        <ButtonDropdown.Option onClick={approveDraftInvoice}>
          Approve Draft Invoice
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  </div>
);

export default BaseInformation;
